import { render, staticRenderFns } from "./promotion_group_item.vue?vue&type=template&id=a3253e86&scoped=true&"
import script from "./promotion_group_item.vue?vue&type=script&lang=ts&"
export * from "./promotion_group_item.vue?vue&type=script&lang=ts&"
import style0 from "./promotion_group_item.vue?vue&type=style&index=0&id=a3253e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3253e86",
  null
  
)

export default component.exports